import {BuyXGetYProps} from '@/interfaces/models/buyXGetY';
import Image from '@/models/image';
import BuyXGetYProduct from '@/models/buyXGetYProduct';
import assetsUtils from '@/utils/url.utils';

export default class BuyXGetY {
  public id: string;
  public placeIds: string[];
  public necessaryProducts: BuyXGetYProduct[];
  public receivedProducts: BuyXGetYProduct[];
  public necessaryCount: number;
  public receivedCount: number;
  public name: string;
  public description: string;
  public terms: string;
  public enabled: boolean;
  public image: Image;
  public clientProgressCount: number;
  public clientProgressReceivedCount: number;

  [key: string]: any;

  constructor(
    id: string,
    placeIds: string[],
    necessaryProducts: BuyXGetYProduct[],
    receivedProducts: BuyXGetYProduct[],
    necessaryCount: number,
    receivedCount: number,
    name: string,
    description: string,
    terms: string,
    enabled: boolean,
    image: Image,
    clientProgressCount: number,
    clientProgressReceivedCount: number,
  ) {
    this.id = id;
    this.placeIds = placeIds;
    this.necessaryProducts = necessaryProducts;
    this.receivedProducts = receivedProducts;
    this.necessaryCount = necessaryCount;
    this.receivedCount = receivedCount;
    this.name = name;
    this.description = description;
    this.terms = terms;
    this.enabled = enabled;
    this.image = image;
    this.clientProgressCount = clientProgressCount;
    this.clientProgressReceivedCount = clientProgressReceivedCount;
  }

  public static createFromRequest(buyXGetYProps: BuyXGetYProps): BuyXGetY {
    const necessaryProducts = buyXGetYProps.necessaryProducts.map(BuyXGetYProduct.createFromRequest);
    const receivedProducts = buyXGetYProps.receivedProducts.map(BuyXGetYProduct.createFromRequest);

    return new BuyXGetY(
      buyXGetYProps.id,
      buyXGetYProps.placeIds,
      necessaryProducts,
      receivedProducts,
      buyXGetYProps.necessaryCount,
      buyXGetYProps.receivedCount,
      buyXGetYProps.name,
      buyXGetYProps.description,
      buyXGetYProps.terms,
      buyXGetYProps.enabled,
      receivedProducts[0].image,
      0,
      0
    )
  }

  get preview(): URL {
    if (this.image.original && this.image.path) {
      return assetsUtils.generateAssetsUrl(this.image.path);
    }

    return require('../assets/images/product-placeholder.png');
  }
}
